import { serviceOperationApi } from "./api";

export async function fetchTableNames({ accessToken }) {
  const res = await serviceOperationApi.get("/Data", {
    params: { table: "nombre_tablas_commondata", country_id: 0 },
    headers: { Authorization: `Bearer ${accessToken}` },
  });
  return res.data;
}